import React from 'react'
import StarsCanvas from '../StarsCanvas'

const Try = () => {
  return (
    <div className='Try bg-[#030014]  h-[100vh] w-full flex flex-col justify-center gap-7 items-center text-6xl text-white font-medium p-5 text-center'>
      <StarsCanvas/>

      <p className='text-6xl text-white font-medium p-5 text-center'>Mahmoud Salah Mohamed</p>

      <p className='text-3xl text-white font-medium text-center'>mmss1001101@gmail.com</p>
      <p className='text-3xl text-white font-medium  text-center'>01022420372</p>

     


    </div>
  )
}

export default Try







// Api Cards


{/* <section className="main-container py-24 text-center" id="native">
  <h2 className="ck-h2-new mt-0 mb-4">Built by Clearbit</h2>
  <p className="ck-leading max-w-xl mx-auto text-gray-600">
    Our native integrations are easy to set up and work right out of the box.
  </p>
  <div className="sm:grid-cols-2 lg:grid-cols-3 sm:gap-12 grid grid-cols-1 gap-8 mt-20 text-left">
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(71, 151, 208)" }}
      >
        <svg
          viewBox="0 0 126 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-32 text-white fill-current"
        >
          <path
            d="M52.5092 9.6515c4.0308-4.24847 9.6424-6.88348 15.8486-6.88348 8.2502 0 15.448 4.6537 19.2812 11.56228 3.3311-1.5055 7.0182-2.3431 10.8974-2.3431 14.8796 0 26.9436 12.3098 26.9436 27.4938 0 15.1858-12.064 27.4956-26.9436 27.4956-1.7823.001-3.5602-.1782-5.3072-.535-3.3755 6.0909-9.8079 10.2062-17.191 10.2062-3.0907 0-6.014-.7221-8.6168-2.0062-3.4219 8.1422-11.3942 13.8512-20.6859 13.8512-9.6761 0-17.9227-6.1935-21.0881-14.8796-1.3833.2971-2.8165.452-4.2871.452C9.83973 74.0654.5 64.5202.5 52.7435c0-7.8918 4.19628-14.7825 10.431-18.4691-1.28356-2.9877-1.99753-6.2854-1.99753-9.7524C8.93347 10.9787 19.8025 0 33.2085 0c7.8709 0 14.8659 3.78566 19.3007 9.6515Z"
            fill="current"
          />
          <path
            d="M18.6006 45.89c-.0783.2072.0285.2505.0534.2864.235.1729.4737.2973.714.4359 1.2747.6843 2.4783.8841 3.737.8841 2.5637 0 4.1553-1.3794 4.1553-3.6001v-.0432c0-2.0532-1.7963-2.7988-3.4823-3.3372l-.219-.0721c-1.2712-.4178-2.3678-.7779-2.3678-1.6244v-.0449c0-.7241.6409-1.2573 1.6343-1.2573 1.1038 0 2.4142.3711 3.258.8429 0 0 .2475.1621.3383-.081.0498-.1297.4772-1.2931.5217-1.4192.048-.1369-.0374-.2378-.1246-.2918-.9632-.5926-2.2949-.9978-3.6728-.9978l-.2564.0018c-2.3464 0-3.9843 1.4336-3.9843 3.4885v.0433c0 2.1665 1.807 2.8689 3.5002 3.3588l.2723.0846c1.2338.3836 2.2967.7132 2.2967 1.5921v.0433c0 .8032-.6907 1.4011-1.8053 1.4011-.4326 0-1.8124-.009-3.3025-.9618-.1799-.1064-.2849-.1837-.4237-.2683-.073-.0469-.2564-.128-.3364.117l-.5061 1.4193Zm37.5313 0c-.0783.2072.0285.2505.0534.2864.235.1729.4737.2973.7139.4359 1.2747.6843 2.4784.8841 3.737.8841 2.5636 0 4.1553-1.3794 4.1553-3.6001v-.0432c0-2.0532-1.7963-2.7988-3.4824-3.3372l-.2189-.0721c-1.2712-.4178-2.368-.7779-2.368-1.6244v-.0449c0-.7241.6409-1.2573 1.6344-1.2573 1.1038 0 2.4141.3711 3.2581.8429 0 0 .2474.1621.3381-.081.0498-.1297.4772-1.2931.5217-1.4192.0482-.1369-.0374-.2378-.1246-.2918-.9632-.5926-2.2949-.9978-3.6728-.9978l-.2565.0018c-2.3465 0-3.9843 1.4336-3.9843 3.4885v.0433c0 2.1665 1.807 2.8689 3.5002 3.3588l.2723.0846c1.2338.3836 2.2986.7132 2.2986 1.5921v.0433c0 .8032-.6926 1.4011-1.8072 1.4011-.4325 0-1.8122-.009-3.3024-.9618-.1799-.1064-.2866-.1801-.4218-.2683-.0464-.0307-.2636-.1153-.3384.117l-.5057 1.4193Zm25.6216-4.3497c0 1.2553-.2314 2.244-.6872 2.9428-.4505.6917-1.1323 1.0284-2.0828 1.0284-.9525 0-1.6308-.335-2.0742-1.0284-.4487-.6969-.6764-1.6875-.6764-2.9428 0-1.2534.2277-2.2404.6764-2.932.4434-.6843 1.1217-1.0175 2.0742-1.0175.9506 0 1.6325.3332 2.0847 1.0175.454.6915.6853 1.6785.6853 2.932Zm2.1401-2.3268c-.2102-.7187-.5377-1.3527-.9738-1.8803-.4363-.5295-.9881-.9544-1.6434-1.2643-.6534-.3079-1.426-.4645-2.2929-.4645-.8689 0-1.6416.1566-2.295.4645-.6551.3099-1.207.735-1.645 1.2643-.4343.5295-.762 1.1635-.9738 1.8803-.2083.7149-.3134 1.4965-.3134 2.3268 0 .8304.1051 1.6137.3134 2.3269.2118.7168.5377 1.3508.9757 1.8802.4361.5295.9898.9527 1.6433 1.2534.655.3008 1.4259.4538 2.2949.4538.867 0 1.6379-.153 2.2929-.4538.6534-.3007 1.207-.724 1.6434-1.2534.4361-.5277.7636-1.1616.9738-1.8802.2102-.7149.3151-1.4984.3151-2.3269 0-.8284-.1052-1.6119-.3152-2.3268Zm17.5734 5.9628c-.071-.2107-.273-.1315-.273-.1315-.311.1207-.642.2323-.995.2881-.3578.0557-.7512.0847-1.1732.0847-1.036 0-1.8586-.3116-2.4478-.9275-.5911-.616-.9223-1.6118-.9188-2.959.0036-1.2265.2955-2.1487.8208-2.8509.5217-.6987 1.3158-1.0573 2.375-1.0573.8831 0 1.556.1027 2.261.3278 0 0 .169.0738.249-.1495.187-.5259.326-.9023.525-1.4804.057-.1639-.081-.2341-.131-.254-.278-.1099-.933-.288-1.428-.3637-.4631-.072-1.0043-.1099-1.6061-.1099-.8992 0-1.7003.1549-2.3856.4647-.6837.3079-1.2641.7329-1.7233 1.2626-.4594.5295-.8083 1.1633-1.0415 1.8801-.2315.7149-.349 1.5002-.349 2.3305 0 1.7956.4789 3.247 1.4244 4.3097.947 1.0662 2.3696 1.6083 4.2248 1.6083 1.0966 0 2.2223-.225 3.0303-.5475 0 0 .155-.0757.087-.2574l-.525-1.4679Zm3.744-4.8385c.101-.6969.292-1.277.586-1.7289.443-.6862 1.12-1.0625 2.07-1.0625.951 0 1.58.3781 2.03 1.0625.299.4519.429 1.0573.481 1.7289h-5.167Zm7.205-1.5327c-.181-.6934-.632-1.394-.927-1.7146-.467-.5079-.923-.8626-1.375-1.0608-.591-.2558-1.3-.425-2.076-.425-.904 0-1.725.1532-2.391.4701-.667.317-1.228.7493-1.668 1.2878-.44.5366-.771 1.176-.981 1.9017-.212.7223-.319 1.5093-.319 2.3394 0 .8448.111 1.6318.33 2.3395.221.7133.573 1.3418 1.05 1.8622.475.5242 1.088.9348 1.821 1.221.729.2846 1.614.4323 2.63.4304 2.092-.0072 3.194-.479 3.648-.733.08-.0449.157-.1242.06-.3511l-.473-1.3418c-.071-.1999-.273-.1261-.273-.1261-.518.1945-1.255.5439-2.973.5404-1.123-.0018-1.956-.3368-2.478-.861-.536-.5366-.798-1.3255-.844-2.4384l7.244.0072s.191-.0036.21-.191c.008-.079.25-1.5054-.215-3.1569Zm-65.2206 1.5327c.1032-.6969.292-1.277.5857-1.7289.4433-.6862 1.1198-1.0625 2.0705-1.0625.9507 0 1.5792.3781 2.0313 1.0625.2973.4519.4273 1.0573.4789 1.7289h-5.1664Zm7.2032-1.5327c-.1816-.6934-.6302-1.394-.9257-1.7146-.4665-.5079-.9223-.8626-1.3744-1.0608-.5911-.2558-1.2996-.425-2.0759-.425-.9026 0-1.7252.1532-2.391.4701-.6675.317-1.2284.7493-1.6681 1.2878-.4398.5366-.7709 1.176-.981 1.9017-.21.7223-.3186 1.5093-.3186 2.3394 0 .8448.1103 1.6318.3294 2.3395.2208.7133.5733 1.3418 1.0504 1.8622.4754.5242 1.0878.9348 1.8212 1.221.7283.2846 1.613.4323 2.6296.4304 2.0919-.0072 3.194-.479 3.648-.733.0802-.0449.1566-.1242.0605-.3511l-.4718-1.3418c-.073-.1999-.2741-.1261-.2741-.1261-.518.1945-1.2534.5439-2.975.5404-1.1215-.0018-1.9547-.3368-2.4764-.861-.536-.5366-.7976-1.3255-.844-2.4384l7.2442.0072s.1904-.0036.2101-.191c.0069-.079.2489-1.5054-.2174-3.1569Zm-22.8615 6.3311c-.2831-.2289-.3223-.2864-.4183-.4341-.1425-.2252-.2155-.5457-.2155-.9527 0-.6448.2101-1.1077.6463-1.4192-.0052.0019.6232-.5493 2.1008-.5296 1.0379.0145 1.9654.1694 1.9654.1694v3.3318h.0017s-.9204.1998-1.9565.2629c-1.4741.0901-2.1293-.4303-2.1239-.4285Zm2.8823-5.1491c-.2937-.0216-.6748-.0343-1.1306-.0343-.6212 0-1.2212.0792-1.7838.2324-.5661.153-1.0753.3927-1.5133.7094-.4373.3158-.7968.7293-1.0504 1.2085-.2563.4827-.3863 1.0518-.3863 1.6894 0 .6484.1103 1.212.3311 1.6732.2208.4628.5395.8482.9453 1.1455.4024.2971.8992.5149 1.4759.6464.568.1315 1.2124.1981 1.9175.1981.7424 0 1.483-.0612 2.2004-.1856.7104-.1225 1.5828-.3008 1.8248-.3565.1698-.0414.3389-.0852.5075-.1315.1799-.0449.1656-.2395.1656-.2395l-.0036-6.7014c0-1.4697-.3881-2.5593-1.1519-3.2346-.7602-.6736-1.8801-1.0141-3.3274-1.0141-.5431 0-1.4172.0758-1.9406.1819 0 0-1.5827.3099-2.2344.8249 0 0-.1424.0901-.0641.2919l.5129 1.394c.064.1801.2368.1188.2368.1188s.0551-.0216.1193-.0595c1.3941-.7671 3.1566-.7437 3.1566-.7437.7834 0 1.3851.1584 1.791.4735.3952.3062.5963.769.5963 1.7451v.3098c-.6231-.09-1.1946-.1421-1.1946-.1421Zm58.4277-3.7759c.055-.1658-.0606-.245-.1087-.263-.1227-.0486-.7388-.1801-1.2142-.2107-.9096-.0558-1.4152.0991-1.8675.3044-.4487.2052-.9471.5366-1.2249.9131v-.8915c0-.1243-.0872-.2234-.2083-.2234h-1.857c-.1209 0-.2081.099-.2081.2234v10.9301c0 .1225.0997.2234.2206.2234h1.9033c.0583-.0004.114-.0241.1551-.0659.041-.0419.064-.0985.0638-.1575v-5.4605c0-.733.0802-1.4641.2405-1.9234.1566-.4539.3703-.8177.6337-1.0789.2653-.2593.5661-.4411.8955-.5438.3364-.1045.7085-.1387.9721-.1387.3792 0 .7958.099.7958.099.1387.0162.2172-.0703.2633-.1981.1248-.335.4773-1.3382.545-1.538"
            fill="#4797D0"
          />
          <path
            d="M75.4474 31.7342c-.2347-.0702-.4477-.1176-.7258-.1683-.2819-.0491-.6176-.0737-.9985-.0737-1.3291 0-2.3763.3647-3.1111 1.0834-.7313.7154-1.2279 1.8041-1.4771 3.2366l-.0904.4821h-1.6682s-.2023-.0071-.2457.2069l-.2725 1.485c-.0199.1403.0434.2296.2383.2296h1.6233l-1.6468 8.9274c-.1283.7189-.2763 1.3098-.4406 1.7585-.1608.4419-.3178.7732-.5128 1.0151-.1878.2315-.3647.4033-.6718.5032-.2527.0824-.5452.121-.8648.121-.177 0-.4134-.0283-.5886-.0632-.1733-.0334-.2655-.0702-.3973-.1246 0 0-.1895-.07-.2654.1141-.0597.1525-.493 1.3077-.5454 1.4499-.0505.1419.0217.2525.1137.2857.2167.0737.3774.1227.6717.1911.4082.093.7529.0982 1.0761.0982.6753 0 1.2928-.0929 1.8039-.2717.5128-.1806.9605-.4945 1.3577-.9187.428-.4594.697-.9397.9535-1.5971.2546-.6488.4732-1.4553.6464-2.3949l1.6558-9.094h2.4195s.2039.007.2456-.2086l.2743-1.4832c.0182-.1419-.0433-.2296-.2402-.2296h-2.349c.0126-.0508.1191-.8539.3882-1.6094.1156-.3208.3322-.5821.5146-.761.1807-.1753.3883-.2997.6159-.3717.2329-.0736.4984-.1086.7891-.1086.2203 0 .4386.0245.6029.0577.2275.0475.316.072.3757.0896.2402.0701.2726.0017.3196-.1104l.5616-1.4972c.0577-.1617-.0849-.23-.1354-.2492ZM42.6259 47.1626c0 .1192-.0884.2157-.2113.2157h-1.9482c-.1228 0-.2095-.0965-.2095-.2157v-15.225c0-.1192.0867-.2156.2095-.2156h1.9482c.1229 0 .2113.0964.2113.2156v15.225Z"
            fill="#4797D0"
          />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Salesforce</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Company and contact details on new leads, contacts, and accounts —
          instantly at your fingertips and automatically refreshed. Get started
          in just minutes.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/salesforce"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(25, 8, 48)" }}
      >
        <svg
          viewBox="0 0 104 32"
          xmlns="http://www.w3.org/2000/svg"
          className="w-40 text-white fill-current"
        >
          <path
            d="M22.855 12.928H12.807a.387.387 0 0 0-.385.39v1.122c0 .215.172.39.385.39h10.048a.387.387 0 0 0 .385-.39v-1.122a.387.387 0 0 0-.385-.39Zm-6.695 4.75H6.111a.387.387 0 0 0-.384.39v1.122c0 .215.172.39.384.39h10.05a.387.387 0 0 0 .384-.39v-1.123a.387.387 0 0 0-.385-.39Zm-9.135-3.449a.35.35 0 0 0 .426-.248c1.16-3.683 4.9-5.862 8.627-5.028a.347.347 0 0 0 .405-.255l.306-1.155a.36.36 0 0 0-.04-.276.35.35 0 0 0-.225-.161c-4.712-1.075-9.447 1.7-10.877 6.374a.358.358 0 0 0 .03.272.35.35 0 0 0 .214.168l1.134.309Zm14.913 4.047a.352.352 0 0 0-.43.247c-1.159 3.685-4.9 5.868-8.627 5.035a.346.346 0 0 0-.406.255l-.3 1.149a.36.36 0 0 0 .04.276.35.35 0 0 0 .226.162c4.711 1.072 9.446-1.703 10.877-6.375a.356.356 0 0 0-.03-.272.347.347 0 0 0-.215-.168l-1.135-.31Zm-2.104-7.438c.568 0 1.029-.466 1.029-1.042 0-.576-.461-1.043-1.03-1.043-.568 0-1.028.467-1.028 1.043 0 .576.46 1.043 1.029 1.043ZM9.138 23.752c.569 0 1.03-.467 1.03-1.042 0-.576-.461-1.043-1.03-1.043-.568 0-1.029.467-1.029 1.043 0 .575.461 1.042 1.03 1.042Zm39.304-9.389a3.913 3.913 0 0 1 2.966-1.303c1.082 0 1.926.34 2.459.991v-.54a.3.3 0 0 1 .28-.287h1.428c.152.01.273.133.281.287v8.03a4.935 4.935 0 0 1-.977 3.15c-.77.948-1.939 1.428-3.474 1.428-2.134 0-3.818-1.368-4.095-3.322a.303.303 0 0 1 .215-.32l1.394-.332h.022a.276.276 0 0 1 .208.052c.06.045.1.112.11.187a2.118 2.118 0 0 0 2.149 1.883c1.667 0 2.444-.866 2.444-2.678v-.703a3.117 3.117 0 0 1-2.444 1.06c-2.373 0-4.093-1.866-4.093-4.434a4.712 4.712 0 0 1 1.127-3.149Zm27.68-1.413h.074c2.55.035 4.13 1.834 4.13 4.713 0 .152-.008.305-.024.457a.279.279 0 0 1-.273.247h-6.063c.037 1.29 1.09 2.311 2.365 2.292a2.128 2.128 0 0 0 2.169-1.534.279.279 0 0 1 .348-.17l1.206.434a.26.26 0 0 1 .158.145.274.274 0 0 1 .014.214 3.994 3.994 0 0 1-3.9 2.749 4.28 4.28 0 0 1-3.077-1.266 4.91 4.91 0 0 1-1.32-3.536c0-2.972 2.13-4.75 4.19-4.75l.003.005Zm-34.303 0c2.596 0 4.209 1.807 4.209 4.714 0 .153-.008.305-.025.457a.275.275 0 0 1-.273.248h-6.063c.035 1.297 1.098 2.323 2.38 2.296a2.125 2.125 0 0 0 2.169-1.534.275.275 0 0 1 .348-.17l1.21.433a.26.26 0 0 1 .159.145.284.284 0 0 1 0 .214 3.995 3.995 0 0 1-3.9 2.749 4.284 4.284 0 0 1-3.081-1.266A4.928 4.928 0 0 1 37.63 17.7c0-2.972 2.131-4.75 4.191-4.75h-.003Zm-9.183 0c1.164 0 2.107.286 2.805.852.47.381.82.895 1.004 1.476a.194.194 0 0 1-.024.146.19.19 0 0 1-.119.086l-1.446.484a.276.276 0 0 1-.199 0 .212.212 0 0 1-.113-.134c-.123-.474-.543-1.27-1.91-1.27-.955 0-1.527.554-1.527 1.092 0 .356.182.816 1.042.982l1.59.302c1.775.362 2.792 1.347 2.792 2.717v-.023c0 1.362-1.293 2.817-3.696 2.817-2.786 0-3.882-1.598-4.083-2.54a.203.203 0 0 1 .148-.224l1.49-.47a.218.218 0 0 1 .081 0 .252.252 0 0 1 .123.03.207.207 0 0 1 .11.136c.188.906.996 1.446 2.158 1.446 1.081 0 1.574-.573 1.574-1.093s-.439-.903-1.193-1.057l-1.672-.33c-1.56-.297-2.53-1.28-2.53-2.557 0-1.555 1.648-2.868 3.595-2.868Zm61.418-2.52a.3.3 0 0 1 .28.303v2.476h1.568a.302.302 0 0 1 .277.302v1.32a.283.283 0 0 1-.277.286h-1.568v4.407c0 .73.285 1.032 1.021 1.032.168-.002.335-.017.502-.042a.276.276 0 0 1 .227.063c.06.057.094.135.095.218v1.238a.285.285 0 0 1-.2.275 3.81 3.81 0 0 1-1.1.145c-1.572 0-2.546-1.024-2.546-2.675v-4.642h-1.357a.3.3 0 0 1-.28-.288v-1.322a.3.3 0 0 1 .28-.302h.353c.426 0 1.144-.151 1.144-1.181v-1.31a.3.3 0 0 1 .28-.302h1.3Zm-29.43 3.996a3.215 3.215 0 0 1 2.843-1.476c1.55 0 3.115 1.106 3.115 3.522v5.591a.301.301 0 0 1-.281.288h-1.43a.301.301 0 0 1-.279-.288v-5.412c0-.684-.212-1.838-1.643-1.838-1.046 0-1.788.833-1.788 2.041v5.21a.3.3 0 0 1-.28.287h-1.448a.301.301 0 0 1-.28-.288v-5.412c.002-.684-.209-1.844-1.64-1.844-1.088 0-1.822.828-1.822 2.06v5.196a.301.301 0 0 1-.28.288h-1.427a.3.3 0 0 1-.278-.288v-8.57a.301.301 0 0 1 .278-.288h1.374c.151.01.272.134.28.288v.516a3.193 3.193 0 0 1 2.414-1.059 2.846 2.846 0 0 1 2.573 1.476Zm21.768-1.476a3 3 0 0 1 2.421 1.066 4.02 4.02 0 0 1 .799 2.582v5.465a.3.3 0 0 1-.277.288H87.89a.304.304 0 0 1-.281-.288V16.89c0-1.353-.628-2.042-1.82-2.042a1.647 1.647 0 0 0-1.356.64 2.676 2.676 0 0 0-.466 1.61v4.965a.301.301 0 0 1-.28.288h-1.443a.302.302 0 0 1-.28-.288v-8.577a.3.3 0 0 1 .28-.288h1.41a.3.3 0 0 1 .278.286v.604a3.088 3.088 0 0 1 2.461-1.138Zm-34.736 1.917c-1.408 0-2.301 1.014-2.301 2.645 0 1.63.882 2.643 2.3 2.643 1.354 0 2.265-1.063 2.265-2.643 0-1.58-.911-2.645-2.264-2.645Zm-9.822-.082a2.096 2.096 0 0 0-2.11 1.88h4.24c-.1-1.16-.914-1.88-2.13-1.88Zm34.31 0a2.097 2.097 0 0 0-2.106 1.88h4.242c-.106-1.16-.914-1.88-2.136-1.88Zm-44.999-7.63v2.88h-.805v-2.88h-1.113v-.698h3.044v.698h-1.126Zm6.146 2.89h-.837l-.767-2.638-.781 2.638h-.82l-1.04-3.59h.856l.66 2.586.742-2.587h.856l.733 2.587.638-2.587h.787l-1.027 3.59Zm2.139-.01V6.457h.793v3.578h-.793Zm2.218 0V6.457h.806v2.874h1.378v.704h-2.184Zm3.383-.003V6.454h.8v3.578h-.8Zm3.791.071c-.977 0-1.76-.71-1.76-1.851 0-1.14.794-1.857 1.767-1.857.972 0 1.758.71 1.758 1.857 0 1.146-.787 1.85-1.765 1.85Zm0-3.054c-.61 0-.966.51-.966 1.197 0 .686.366 1.202.966 1.202s.954-.523.954-1.196c0-.674-.357-1.203-.948-1.203h-.006Z"
            fill="fill-current"
          />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Segment</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Add valuable user insights wherever they're most effective via Segment
          to analytics platforms and data warehouses, CRMs, marketing tools, and
          more.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/segment"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(92, 76, 159)" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 120 60"
          className="w-[10.5rem] text-white fill-current"
        >
          <path d="M40.398 16.414l-9.617-5.228v37.628l9.617-7.66zM26.3 16.75v23.846l-7.744 3.383V14.46zM8.193 18.37l-.028 21.36 5.927-1.566V19.32z" />
          <path d="M55.85 30.438l-4.197-6.796H49.45v12.505h2.077V27.02l4.267 6.853 4.295-6.9v9.184h2.063V23.64H60zm13.297 5.708l-.014-1.13c-.622.904-1.64 1.342-2.727 1.342-1.583 0-2.7-1.03-2.7-2.515 0-1.625 1.03-2.586 3.094-2.9l2.26-.353v-.14c0-.933-.692-1.44-1.893-1.44-1.145 0-2.12.48-2.967 1.243v-2.02c.763-.622 1.823-1.03 3.1-1.03 2.444 0 3.773 1.243 3.773 3.335v5.624zm-2.247-1.47c1.286 0 2.176-.834 2.176-2.035v-.48l-1.95.325c-.947.155-1.427.565-1.427 1.2.014.608.5 1 1.2 1m11.05-5.308c-.085-.057-.268-.07-.537-.07-1.512 0-2.444 1.173-2.444 2.98v3.857h-2.05v-8.76h2.035v1.498c.424-1.017 1.47-1.68 2.6-1.68.226 0 .353.014.396.057zm1.33 6.768h2.05V32.67l.452-.4 3.123 3.886h2.53L83.348 31.2l3.8-3.815h-2.53l-3.292 3.306v-7.05h-2.05zm15.938-.72c-.904.565-2.077.933-3.377.933-2.897 0-4.72-1.964-4.72-4.606 0-2.628 1.823-4.564 4.394-4.564 2.558 0 4.197 1.922 4.197 4.522 0 .283 0 .452-.057.72H89.17c.155 1.215 1.16 2.176 2.798 2.176 1.102 0 2.176-.396 3.236-1.173v1.992zm-1.526-4.55c-.127-1.2-.975-2.02-2.218-2.02s-2.162.975-2.303 2.02zm7.235 3.6c.34 0 .692-.07.96-.268v1.837c-.34.198-.862.325-1.568.325-1.766 0-2.798-1.074-2.798-2.9v-4.3h-1.554l3.603-4.592v2.84h2.317v1.752H99.57v3.928c0 1 .424 1.4 1.356 1.4m10.908-2.722c0 2.572-1.978 4.592-4.663 4.592s-4.663-2.02-4.663-4.592 1.978-4.592 4.663-4.592c2.67 0 4.663 2.02 4.663 4.592m-7.277 0c0 1.498 1.145 2.7 2.6 2.7 1.47 0 2.6-1.2 2.6-2.7s-1.145-2.7-2.6-2.7-2.6 1.2-2.6 2.7" />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Marketo</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Automatically enrich leads with accurate data for better
          qualification, improved segmentation, hyper-targeted nurture flows,
          personalized messaging, and more.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/marketo"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(236, 101, 60)" }}
      >
        <svg
          viewBox="0 0 106 31"
          xmlns="http://www.w3.org/2000/svg"
          className="w-28 text-white fill-current"
        >
          <g clipPath="url(#clip-hubspot-mono)">
            <path d="M11.5651 5.62866V14.0394H3.8408V5.62866H0.173584V25.7058H3.8408V17.5682H11.5651V25.7058H15.2323V5.62866H11.5651Z" />
            <path d="M26.9691 19.2163C26.9691 20.0209 26.6495 20.7926 26.0805 21.3616C25.5116 21.9305 24.7399 22.2502 23.9353 22.2502C23.1306 22.2502 22.359 21.9305 21.79 21.3616C21.221 20.7926 20.9014 20.0209 20.9014 19.2163V10.6169H17.4229V19.2163C17.4229 20.9418 18.1083 22.5967 19.3285 23.8168C20.5486 25.037 22.2034 25.7224 23.929 25.7224C25.6545 25.7224 27.3094 25.037 28.5295 23.8168C29.7496 22.5967 30.4351 20.9418 30.4351 19.2163V10.6169H26.9691V19.2163Z" />
            <path d="M52.7417 11.5023C52.7417 9.73968 53.9078 9.18088 55.1853 9.18088C56.2148 9.18088 57.575 9.96428 58.4644 10.9148L60.7427 8.23039C59.6053 6.69235 57.2983 5.62866 55.4099 5.62866C51.6367 5.62866 48.9074 7.83869 48.9074 11.5023C48.9074 18.2995 57.2156 16.1434 57.2156 19.9472C57.2156 21.1204 56.0765 22.1572 54.772 22.1572C52.7147 22.1572 52.0481 21.151 51.103 20.0873L48.575 22.716C50.192 24.7014 52.1865 25.7094 54.5762 25.7094C58.1607 25.7094 61.0446 23.4724 61.0446 19.9759C61.0446 12.4295 52.7363 14.7742 52.7363 11.5023" />
            <path d="M104.141 22.4985C102.085 22.4985 101.501 21.6091 101.501 20.2471V14.219H104.696V11.1644H101.501V7.13428L97.9741 8.71724V20.9964C97.9741 24.1372 100.141 25.7201 103.113 25.7201C103.579 25.7286 104.045 25.6913 104.504 25.6087L105.364 22.441C104.976 22.4679 104.531 22.4949 104.141 22.4949" />
            <path d="M40.2095 10.7176C38.4864 10.7176 37.2844 11.2171 36.1219 12.358V5.74951H32.6379V17.9981C32.6379 22.5835 35.953 25.7242 39.6777 25.7242C43.8103 25.7242 47.4452 22.5278 47.4452 18.2227C47.4452 13.9715 44.0996 10.7194 40.2095 10.7194V10.7176ZM40.188 22.2187C39.4062 22.2187 38.6419 21.9869 37.9919 21.5526C37.3418 21.1182 36.8352 20.5008 36.536 19.7785C36.2368 19.0563 36.1585 18.2615 36.311 17.4947C36.4636 16.7279 36.84 16.0235 37.3929 15.4707C37.9457 14.9179 38.65 14.5414 39.4168 14.3889C40.1836 14.2364 40.9784 14.3146 41.7007 14.6138C42.423 14.913 43.0404 15.4197 43.4747 16.0697C43.9091 16.7198 44.1409 17.484 44.1409 18.2658C44.1409 19.3142 43.7244 20.3196 42.9831 21.061C42.2418 21.8023 41.2364 22.2187 40.188 22.2187Z" />
            <path d="M78.0389 18.0389C78.0389 13.7266 74.4112 10.5374 70.2714 10.5374C66.5467 10.5374 63.2317 13.6781 63.2317 18.2635V30.5193H66.7156V23.9018C67.8763 25.0409 69.0802 25.5422 70.8015 25.5422C74.6915 25.5422 78.0371 22.2919 78.0371 18.0389H78.0389ZM74.74 17.9958C74.74 18.7776 74.5082 19.5418 74.0738 20.1919C73.6395 20.8419 73.0221 21.3486 72.2998 21.6478C71.5775 21.947 70.7827 22.0252 70.0159 21.8727C69.2492 21.7202 68.5448 21.3437 67.992 20.7909C67.4392 20.2381 67.0627 19.5337 66.9102 18.7669C66.7577 18.0001 66.8359 17.2054 67.1351 16.4831C67.4343 15.7608 67.941 15.1434 68.591 14.709C69.2411 14.2747 70.0053 14.0429 70.7871 14.0429C71.8355 14.0429 72.8409 14.4593 73.5822 15.2006C74.3236 15.942 74.74 16.9474 74.74 17.9958Z" />
            <path
              opacity="var(--svg-path-opacity)"
              d="M89.2939 10.3688V6.86871C89.7565 6.65259 90.1481 6.30952 90.4233 5.87946C90.6984 5.44939 90.8458 4.95002 90.8481 4.43948V4.35862C90.8481 3.64382 90.5642 2.9583 90.0587 2.45285C89.5533 1.94741 88.8678 1.66346 88.153 1.66346H88.0721C87.3573 1.66346 86.6718 1.94741 86.1664 2.45285C85.6609 2.9583 85.377 3.64382 85.377 4.35862V4.43948C85.3793 4.95002 85.5267 5.44939 85.8018 5.87946C86.077 6.30952 86.4686 6.65259 86.9312 6.86871V10.3688C85.6017 10.5722 84.3497 11.1233 83.3017 11.9662L73.7033 4.48979C73.7713 4.24324 73.8075 3.98905 73.8111 3.73334C73.8122 3.1327 73.6351 2.54522 73.3022 2.04524C72.9694 1.54525 72.4957 1.15521 71.9412 0.924446C71.3866 0.693685 70.7761 0.632572 70.1868 0.748837C69.5975 0.865103 69.056 1.15352 68.6306 1.57762C68.2053 2.00171 67.9152 2.54243 67.7972 3.13137C67.6792 3.72031 67.7385 4.33102 67.9676 4.88625C68.1968 5.44149 68.5854 5.9163 69.0844 6.25063C69.5834 6.58496 70.1703 6.76379 70.771 6.7645C71.2962 6.76215 71.8117 6.62214 72.2659 6.35843L81.7187 13.7126C80.8694 14.9955 80.4262 16.5045 80.447 18.0429C80.4679 19.5813 80.9517 21.0778 81.8355 22.3371L78.9607 25.212C78.7282 25.1377 78.486 25.0984 78.242 25.0952C77.7489 25.0955 77.2669 25.2421 76.8571 25.5162C76.4473 25.7904 76.1279 26.1799 75.9393 26.6356C75.7508 27.0912 75.7016 27.5925 75.7979 28.0761C75.8941 28.5597 76.1316 29.0039 76.4803 29.3526C76.829 29.7013 77.2732 29.9387 77.7568 30.035C78.2404 30.1313 78.7417 30.0821 79.1973 29.8935C79.653 29.705 80.0425 29.3856 80.3166 28.9758C80.5908 28.5659 80.7373 28.084 80.7377 27.5909C80.7346 27.3469 80.6952 27.1047 80.6209 26.8722L83.4652 24.0279C84.3927 24.7416 85.4712 25.2336 86.6181 25.4661C87.7651 25.6987 88.95 25.6657 90.0822 25.3696C91.2144 25.0735 92.2639 24.5222 93.1501 23.7579C94.0364 22.9936 94.736 22.0367 95.1953 20.9603C95.6546 19.8839 95.8615 18.7167 95.8001 17.548C95.7386 16.3793 95.4106 15.2402 94.841 14.2179C94.2713 13.1956 93.4753 12.3172 92.5138 11.6501C91.5524 10.9829 90.4509 10.5446 89.2939 10.3688ZM88.1152 21.879C87.3372 21.8783 86.5769 21.6469 85.9303 21.2142C85.2837 20.7815 84.7799 20.1668 84.4826 19.4478C84.1852 18.7288 84.1077 17.9378 84.2598 17.1748C84.4119 16.4118 84.7868 15.711 85.3371 15.161C85.8873 14.611 86.5883 14.2364 87.3514 14.0847C88.1145 13.9329 88.9054 14.0108 89.6243 14.3085C90.3431 14.6061 90.9576 15.1102 91.39 15.757C91.8224 16.4037 92.0534 17.1642 92.0538 17.9422C92.0538 18.9858 91.6392 19.9867 90.9013 20.7247C90.1633 21.4626 89.1624 21.8772 88.1188 21.8772"
            />
          </g>
          <defs>
            <clipPath id="clip-hubspot-mono">
              <rect
                width="105.19"
                height="29.8175"
                fill="white"
                transform="translate(0.174072 0.692871)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">HubSpot</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Automatically enrich leads with contact-level and firmographic data to
          power smarter lead scoring, lead routing, and more personalized email
          campaigns.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/hubspot"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(20, 140, 252)" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 72 72"
          className="w-[4.375rem] text-white fill-current"
        >
          <defs>
            <linearGradient
              id="white-icon-a"
              x1="0%"
              x2="100%"
              y1="0%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#FFF" stopOpacity="0.753" />
              <stop offset="100%" stopColor="#FFF" stopOpacity="0.501" />
            </linearGradient>
            <linearGradient
              id="white-icon-b"
              x1="37.5%"
              x2="62.5%"
              y1="0%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#FFF" stopOpacity="0.946" />
              <stop offset="100%" stopColor="#FFF" stopOpacity="0.903" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd">
            <path
              fill="#FFF"
              d="M72,36 L72,52.770861 L71.9958819,53.6375008 C71.9369091,59.6728148 71.2457056,61.9905403 69.9965047,64.3263428 C68.6892015,66.7707872 66.7707872,68.6892015 64.3263428,69.9965047 L64.0001583,70.1671829 C61.6579559,71.3643165 59.1600786,72 52.770861,72 L36,72 L36,36 L72,36 Z"
              opacity="0.204"
            />
            <path
              fill="url(#white-icon-a)"
              d="M64.3263428,2.00349528 C66.7707872,3.31079847 68.6892015,5.22921278 69.9965047,7.67365722 L70.1671829,7.99984171 C71.3643165,10.3420441 72,12.8399214 72,19.229139 L72,36 L36,36 L36,0 L52.770861,0 C59.4572515,0 61.8818983,0.696192084 64.3263428,2.00349528 Z"
            />
            <path
              fill="url(#white-icon-b)"
              d="M36,0 L36,72 L19.229139,72 L18.3624992,71.9958819 C12.3271852,71.9369091 10.0094597,71.2457056 7.67365722,69.9965047 C5.22921278,68.6892015 3.31079847,66.7707872 2.00349528,64.3263428 L1.83281705,64.0001583 C0.635683537,61.6579559 0,59.1600786 0,52.770861 L0,19.229139 C0,12.5427485 0.696192084,10.1181017 2.00349528,7.67365722 C3.31079847,5.22921278 5.22921278,3.31079847 7.67365722,2.00349528 L7.99984171,1.83281705 C10.3420441,0.635683537 12.8399214,0 19.229139,0 L36,0 Z"
            />
          </g>
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Clearbit APIs</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Build your own solutions with our suite of 9 modern, flexible business
          data APIs.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/docs"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(255, 73, 44)" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 1000"
          className="w-20 text-white fill-current"
        >
          <path
            d="M500,0C223.9,0,0,223.9,0,500s223.9,500,500,500,500-223.9,500-500S776.1,0,500,0Zm87.2,412.4c0-21.9,4.3-40.2,13.1-54.4s24-27.1,45.9-38.2l10.1-4.9c17.8-9,22.4-16.7,22.4-26,0-11.1-9.5-19.1-25-19.1-18.3,0-32.2,9.5-41.8,28.9l-24.7-24.8c5.4-11.6,14.1-20.9,25.8-28.1a70.8,70.8,0,0,1,38.9-11.1c17.8,0,33.3,4.6,45.9,14.2s19.4,22.7,19.4,39.4c0,26.6-15,42.9-43.1,57.3l-15.7,8c-16.8,8.5-25.1,16-27.4,29.4h85.4v35.4H587.2ZM505.1,785.7c-157.8,0-285.7-127.9-285.7-285.7S347.3,214.3,505.1,214.3a286.4,286.4,0,0,1,55.9,5.5L505.1,336.7c-90,0-163.3,73.3-163.3,163.3s73.3,163.3,163.3,163.3a162.8,162.8,0,0,0,106.4-39.6l61.8,107.2A283.9,283.9,0,0,1,505.1,785.7ZM705,704.1,634.3,581.6H492.9l70.7-122.4H705l70.7,122.4Z"
            fill="#fff"
          />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">G2</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Create and convert more pipeline by combining Clearbit’s company
          intelligence and web intent data with G2’s buyer intent signals to
          engage the right customers at the right time.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/g2"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(71, 151, 208)" }}
      >
        <svg
          viewBox="0 0 126 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-32 text-white fill-current"
        >
          <path
            d="M52.5092 9.6515c4.0308-4.24847 9.6424-6.88348 15.8486-6.88348 8.2502 0 15.448 4.6537 19.2812 11.56228 3.3311-1.5055 7.0182-2.3431 10.8974-2.3431 14.8796 0 26.9436 12.3098 26.9436 27.4938 0 15.1858-12.064 27.4956-26.9436 27.4956-1.7823.001-3.5602-.1782-5.3072-.535-3.3755 6.0909-9.8079 10.2062-17.191 10.2062-3.0907 0-6.014-.7221-8.6168-2.0062-3.4219 8.1422-11.3942 13.8512-20.6859 13.8512-9.6761 0-17.9227-6.1935-21.0881-14.8796-1.3833.2971-2.8165.452-4.2871.452C9.83973 74.0654.5 64.5202.5 52.7435c0-7.8918 4.19628-14.7825 10.431-18.4691-1.28356-2.9877-1.99753-6.2854-1.99753-9.7524C8.93347 10.9787 19.8025 0 33.2085 0c7.8709 0 14.8659 3.78566 19.3007 9.6515Z"
            fill="current"
          />
          <path
            d="M18.6006 45.89c-.0783.2072.0285.2505.0534.2864.235.1729.4737.2973.714.4359 1.2747.6843 2.4783.8841 3.737.8841 2.5637 0 4.1553-1.3794 4.1553-3.6001v-.0432c0-2.0532-1.7963-2.7988-3.4823-3.3372l-.219-.0721c-1.2712-.4178-2.3678-.7779-2.3678-1.6244v-.0449c0-.7241.6409-1.2573 1.6343-1.2573 1.1038 0 2.4142.3711 3.258.8429 0 0 .2475.1621.3383-.081.0498-.1297.4772-1.2931.5217-1.4192.048-.1369-.0374-.2378-.1246-.2918-.9632-.5926-2.2949-.9978-3.6728-.9978l-.2564.0018c-2.3464 0-3.9843 1.4336-3.9843 3.4885v.0433c0 2.1665 1.807 2.8689 3.5002 3.3588l.2723.0846c1.2338.3836 2.2967.7132 2.2967 1.5921v.0433c0 .8032-.6907 1.4011-1.8053 1.4011-.4326 0-1.8124-.009-3.3025-.9618-.1799-.1064-.2849-.1837-.4237-.2683-.073-.0469-.2564-.128-.3364.117l-.5061 1.4193Zm37.5313 0c-.0783.2072.0285.2505.0534.2864.235.1729.4737.2973.7139.4359 1.2747.6843 2.4784.8841 3.737.8841 2.5636 0 4.1553-1.3794 4.1553-3.6001v-.0432c0-2.0532-1.7963-2.7988-3.4824-3.3372l-.2189-.0721c-1.2712-.4178-2.368-.7779-2.368-1.6244v-.0449c0-.7241.6409-1.2573 1.6344-1.2573 1.1038 0 2.4141.3711 3.2581.8429 0 0 .2474.1621.3381-.081.0498-.1297.4772-1.2931.5217-1.4192.0482-.1369-.0374-.2378-.1246-.2918-.9632-.5926-2.2949-.9978-3.6728-.9978l-.2565.0018c-2.3465 0-3.9843 1.4336-3.9843 3.4885v.0433c0 2.1665 1.807 2.8689 3.5002 3.3588l.2723.0846c1.2338.3836 2.2986.7132 2.2986 1.5921v.0433c0 .8032-.6926 1.4011-1.8072 1.4011-.4325 0-1.8122-.009-3.3024-.9618-.1799-.1064-.2866-.1801-.4218-.2683-.0464-.0307-.2636-.1153-.3384.117l-.5057 1.4193Zm25.6216-4.3497c0 1.2553-.2314 2.244-.6872 2.9428-.4505.6917-1.1323 1.0284-2.0828 1.0284-.9525 0-1.6308-.335-2.0742-1.0284-.4487-.6969-.6764-1.6875-.6764-2.9428 0-1.2534.2277-2.2404.6764-2.932.4434-.6843 1.1217-1.0175 2.0742-1.0175.9506 0 1.6325.3332 2.0847 1.0175.454.6915.6853 1.6785.6853 2.932Zm2.1401-2.3268c-.2102-.7187-.5377-1.3527-.9738-1.8803-.4363-.5295-.9881-.9544-1.6434-1.2643-.6534-.3079-1.426-.4645-2.2929-.4645-.8689 0-1.6416.1566-2.295.4645-.6551.3099-1.207.735-1.645 1.2643-.4343.5295-.762 1.1635-.9738 1.8803-.2083.7149-.3134 1.4965-.3134 2.3268 0 .8304.1051 1.6137.3134 2.3269.2118.7168.5377 1.3508.9757 1.8802.4361.5295.9898.9527 1.6433 1.2534.655.3008 1.4259.4538 2.2949.4538.867 0 1.6379-.153 2.2929-.4538.6534-.3007 1.207-.724 1.6434-1.2534.4361-.5277.7636-1.1616.9738-1.8802.2102-.7149.3151-1.4984.3151-2.3269 0-.8284-.1052-1.6119-.3152-2.3268Zm17.5734 5.9628c-.071-.2107-.273-.1315-.273-.1315-.311.1207-.642.2323-.995.2881-.3578.0557-.7512.0847-1.1732.0847-1.036 0-1.8586-.3116-2.4478-.9275-.5911-.616-.9223-1.6118-.9188-2.959.0036-1.2265.2955-2.1487.8208-2.8509.5217-.6987 1.3158-1.0573 2.375-1.0573.8831 0 1.556.1027 2.261.3278 0 0 .169.0738.249-.1495.187-.5259.326-.9023.525-1.4804.057-.1639-.081-.2341-.131-.254-.278-.1099-.933-.288-1.428-.3637-.4631-.072-1.0043-.1099-1.6061-.1099-.8992 0-1.7003.1549-2.3856.4647-.6837.3079-1.2641.7329-1.7233 1.2626-.4594.5295-.8083 1.1633-1.0415 1.8801-.2315.7149-.349 1.5002-.349 2.3305 0 1.7956.4789 3.247 1.4244 4.3097.947 1.0662 2.3696 1.6083 4.2248 1.6083 1.0966 0 2.2223-.225 3.0303-.5475 0 0 .155-.0757.087-.2574l-.525-1.4679Zm3.744-4.8385c.101-.6969.292-1.277.586-1.7289.443-.6862 1.12-1.0625 2.07-1.0625.951 0 1.58.3781 2.03 1.0625.299.4519.429 1.0573.481 1.7289h-5.167Zm7.205-1.5327c-.181-.6934-.632-1.394-.927-1.7146-.467-.5079-.923-.8626-1.375-1.0608-.591-.2558-1.3-.425-2.076-.425-.904 0-1.725.1532-2.391.4701-.667.317-1.228.7493-1.668 1.2878-.44.5366-.771 1.176-.981 1.9017-.212.7223-.319 1.5093-.319 2.3394 0 .8448.111 1.6318.33 2.3395.221.7133.573 1.3418 1.05 1.8622.475.5242 1.088.9348 1.821 1.221.729.2846 1.614.4323 2.63.4304 2.092-.0072 3.194-.479 3.648-.733.08-.0449.157-.1242.06-.3511l-.473-1.3418c-.071-.1999-.273-.1261-.273-.1261-.518.1945-1.255.5439-2.973.5404-1.123-.0018-1.956-.3368-2.478-.861-.536-.5366-.798-1.3255-.844-2.4384l7.244.0072s.191-.0036.21-.191c.008-.079.25-1.5054-.215-3.1569Zm-65.2206 1.5327c.1032-.6969.292-1.277.5857-1.7289.4433-.6862 1.1198-1.0625 2.0705-1.0625.9507 0 1.5792.3781 2.0313 1.0625.2973.4519.4273 1.0573.4789 1.7289h-5.1664Zm7.2032-1.5327c-.1816-.6934-.6302-1.394-.9257-1.7146-.4665-.5079-.9223-.8626-1.3744-1.0608-.5911-.2558-1.2996-.425-2.0759-.425-.9026 0-1.7252.1532-2.391.4701-.6675.317-1.2284.7493-1.6681 1.2878-.4398.5366-.7709 1.176-.981 1.9017-.21.7223-.3186 1.5093-.3186 2.3394 0 .8448.1103 1.6318.3294 2.3395.2208.7133.5733 1.3418 1.0504 1.8622.4754.5242 1.0878.9348 1.8212 1.221.7283.2846 1.613.4323 2.6296.4304 2.0919-.0072 3.194-.479 3.648-.733.0802-.0449.1566-.1242.0605-.3511l-.4718-1.3418c-.073-.1999-.2741-.1261-.2741-.1261-.518.1945-1.2534.5439-2.975.5404-1.1215-.0018-1.9547-.3368-2.4764-.861-.536-.5366-.7976-1.3255-.844-2.4384l7.2442.0072s.1904-.0036.2101-.191c.0069-.079.2489-1.5054-.2174-3.1569Zm-22.8615 6.3311c-.2831-.2289-.3223-.2864-.4183-.4341-.1425-.2252-.2155-.5457-.2155-.9527 0-.6448.2101-1.1077.6463-1.4192-.0052.0019.6232-.5493 2.1008-.5296 1.0379.0145 1.9654.1694 1.9654.1694v3.3318h.0017s-.9204.1998-1.9565.2629c-1.4741.0901-2.1293-.4303-2.1239-.4285Zm2.8823-5.1491c-.2937-.0216-.6748-.0343-1.1306-.0343-.6212 0-1.2212.0792-1.7838.2324-.5661.153-1.0753.3927-1.5133.7094-.4373.3158-.7968.7293-1.0504 1.2085-.2563.4827-.3863 1.0518-.3863 1.6894 0 .6484.1103 1.212.3311 1.6732.2208.4628.5395.8482.9453 1.1455.4024.2971.8992.5149 1.4759.6464.568.1315 1.2124.1981 1.9175.1981.7424 0 1.483-.0612 2.2004-.1856.7104-.1225 1.5828-.3008 1.8248-.3565.1698-.0414.3389-.0852.5075-.1315.1799-.0449.1656-.2395.1656-.2395l-.0036-6.7014c0-1.4697-.3881-2.5593-1.1519-3.2346-.7602-.6736-1.8801-1.0141-3.3274-1.0141-.5431 0-1.4172.0758-1.9406.1819 0 0-1.5827.3099-2.2344.8249 0 0-.1424.0901-.0641.2919l.5129 1.394c.064.1801.2368.1188.2368.1188s.0551-.0216.1193-.0595c1.3941-.7671 3.1566-.7437 3.1566-.7437.7834 0 1.3851.1584 1.791.4735.3952.3062.5963.769.5963 1.7451v.3098c-.6231-.09-1.1946-.1421-1.1946-.1421Zm58.4277-3.7759c.055-.1658-.0606-.245-.1087-.263-.1227-.0486-.7388-.1801-1.2142-.2107-.9096-.0558-1.4152.0991-1.8675.3044-.4487.2052-.9471.5366-1.2249.9131v-.8915c0-.1243-.0872-.2234-.2083-.2234h-1.857c-.1209 0-.2081.099-.2081.2234v10.9301c0 .1225.0997.2234.2206.2234h1.9033c.0583-.0004.114-.0241.1551-.0659.041-.0419.064-.0985.0638-.1575v-5.4605c0-.733.0802-1.4641.2405-1.9234.1566-.4539.3703-.8177.6337-1.0789.2653-.2593.5661-.4411.8955-.5438.3364-.1045.7085-.1387.9721-.1387.3792 0 .7958.099.7958.099.1387.0162.2172-.0703.2633-.1981.1248-.335.4773-1.3382.545-1.538"
            fill="#4797D0"
          />
          <path
            d="M75.4474 31.7342c-.2347-.0702-.4477-.1176-.7258-.1683-.2819-.0491-.6176-.0737-.9985-.0737-1.3291 0-2.3763.3647-3.1111 1.0834-.7313.7154-1.2279 1.8041-1.4771 3.2366l-.0904.4821h-1.6682s-.2023-.0071-.2457.2069l-.2725 1.485c-.0199.1403.0434.2296.2383.2296h1.6233l-1.6468 8.9274c-.1283.7189-.2763 1.3098-.4406 1.7585-.1608.4419-.3178.7732-.5128 1.0151-.1878.2315-.3647.4033-.6718.5032-.2527.0824-.5452.121-.8648.121-.177 0-.4134-.0283-.5886-.0632-.1733-.0334-.2655-.0702-.3973-.1246 0 0-.1895-.07-.2654.1141-.0597.1525-.493 1.3077-.5454 1.4499-.0505.1419.0217.2525.1137.2857.2167.0737.3774.1227.6717.1911.4082.093.7529.0982 1.0761.0982.6753 0 1.2928-.0929 1.8039-.2717.5128-.1806.9605-.4945 1.3577-.9187.428-.4594.697-.9397.9535-1.5971.2546-.6488.4732-1.4553.6464-2.3949l1.6558-9.094h2.4195s.2039.007.2456-.2086l.2743-1.4832c.0182-.1419-.0433-.2296-.2402-.2296h-2.349c.0126-.0508.1191-.8539.3882-1.6094.1156-.3208.3322-.5821.5146-.761.1807-.1753.3883-.2997.6159-.3717.2329-.0736.4984-.1086.7891-.1086.2203 0 .4386.0245.6029.0577.2275.0475.316.072.3757.0896.2402.0701.2726.0017.3196-.1104l.5616-1.4972c.0577-.1617-.0849-.23-.1354-.2492ZM42.6259 47.1626c0 .1192-.0884.2157-.2113.2157h-1.9482c-.1228 0-.2095-.0965-.2095-.2157v-15.225c0-.1192.0867-.2156.2095-.2156h1.9482c.1229 0 .2113.0964.2113.2156v15.225Z"
            fill="#4797D0"
          />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Pardot</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Automatically enrich leads with valuable company and contact-level
          data to power smarter lead scoring, shorter forms, and more
          personalized email campaigns.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/pardot"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(67, 25, 72)" }}
      >
        <svg
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[4.375rem] text-white fill-current"
        >
          <path
            d="M15.3077 45.5963c0 4.3269-2.8846 7.2115-7.21152 7.2115S.884644 49.9232.884644 45.5963s2.884616-7.2115 7.211536-7.2115h7.21152v7.2115Zm2.8846-1.4423c0-2.6015 2.8847-5.7692 7.2116-5.7692s7.2115 3.1677 7.2115 5.7692v20.1923c0 2.6015-2.8846 5.7692-7.2115 5.7692s-7.2116-3.1677-7.2116-5.7692V44.154Zm8.6539-25.9615c2.6015 0 5.7692 2.8846 5.7692 7.2115s-3.1677 7.2115-5.7692 7.2115H6.65387c-2.60154 0-5.769226-2.8846-5.769226-7.2115s3.167686-7.2115 5.769226-7.2115H26.8462ZM25.4039.884766c4.3269 0 7.2115 2.884614 7.2115 7.211534v7.2115h-7.2115c-4.3269 0-7.2116-2.8846-7.2116-7.2115 0-4.32692 2.8847-7.211534 7.2116-7.211534Zm20.1923 0c4.3269 0 7.2115 3.167684 7.2115 5.769234v20.1923c0 2.6015-2.8846 5.7692-7.2115 5.7692s-7.2116-3.1677-7.2116-5.7692V6.654c0-2.60155 2.8847-5.769234 7.2116-5.769234ZM62.9039 18.1925c4.3269 0 7.2115 2.8846 7.2115 7.2115s-2.8846 7.2115-7.2115 7.2115h-7.2116V25.404c0-4.3269 2.8847-7.2115 7.2116-7.2115Zm-17.3077 37.5c4.3269 0 7.2115 2.8846 7.2115 7.2115s-2.8846 7.2115-7.2115 7.2115-7.2116-2.8846-7.2116-7.2115v-7.2115h7.2116Zm18.75-17.3077c2.6015 0 5.7692 2.8846 5.7692 7.2115s-3.1677 7.2115-5.7692 7.2115H44.1539c-2.6016 0-5.7693-2.8846-5.7693-7.2115s3.1677-7.2115 5.7693-7.2115h20.1923Z"
            fill="current"
          />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Slack</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Send the fully enriched profile of each new sign-up right to your
          preferred Slack channel — and gain instant visibility into who’s
          interested in your product or platform.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/slack"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
    <div
      className="relative flex flex-col bg-white rounded-lg"
      style={{ boxShadow: "rgba(25, 69, 173, 0.1) 0px 15px 40px" }}
    >
      <div
        className="h-44 flex items-center justify-center rounded-t-lg"
        style={{ backgroundColor: "rgb(233, 88, 41)" }}
      >
        <svg
          viewBox="0 0 148 67"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-36 text-white fill-current"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M99.6709 7.76952h-5.4986l3.8882-3.84789c-.3057-.42485-.6468-.82352-1.0184-1.19114-.3715-.36763-.7732-.70421-1.2026-1.00684l-3.8881 3.8479V.129977C91.4426.045589 90.9193.00096998 90.3871 0h-.0109c-.5331.00096998-1.0555.045589-1.5643.129977V5.57155l-3.888-3.8479c-.4295.30263-.8321.63921-1.2028 1.00684l-.0019.00195c-.3714.36664-.7116.76434-1.0164 1.18919l3.8883 3.84789h-5.4986s-.1314 1.02139-.1314 1.55004v.00678c0 .52766.0451 1.04656.1314 1.55096h5.4986l-3.8883 3.847c.6117.8497 1.3624 1.5936 2.2211 2.1979l3.888-3.8479v5.4416c.5088.0844 1.0301.129 1.5625.1301h.0136c.5322-.0011 1.0556-.0457 1.5634-.1301v-5.4416l3.8892 3.8479c.4283-.3016.83-.6392 1.2015-1.0068h.0011c.3705-.3676.7116-.7663 1.0173-1.1911l-3.8892-3.847h5.4996c.0853-.5034.1304-1.02038.1304-1.54805v-.01261c0-.52766-.0451-1.0437-.1304-1.54712ZM108.87 47.4001c-1.57-1.4599-2.393-3.7626-2.469-6.9083h19.805c.038-.4112.076-.906.113-1.4878.038-.5802.058-1.132.058-1.6569 0-1.9098-.266-3.6781-.795-5.3067-.53-1.6286-1.306-3.0322-2.326-4.2117-1.022-1.1795-2.289-2.1057-3.803-2.7799-1.513-.6741-3.272-1.0116-5.277-1.0116-2.346 0-4.38.4025-6.101 1.2075-1.721.8061-3.149 1.8915-4.284 3.2572-1.134 1.3678-1.977 2.9769-2.525 4.8296-.549 1.8546-.823 3.8478-.823 5.9808 0 2.1728.284 4.1661.851 5.9818.568 1.816 1.467 3.3892 2.696 4.718 1.229 1.329 2.79 2.3581 4.682 3.0885 1.891.7304 4.16 1.0952 6.81 1.0952 1.815 0 3.47-.132 4.965-.3929 1.493-.2629 2.865-.6548 4.114-1.1795-.038-.7866-.151-1.5811-.34-2.3872-.19-.805-.436-1.4879-.738-2.0495-2.422.9359-4.975 1.4045-7.661 1.4045-3.065 0-5.382-.7313-6.952-2.1911ZM55.8402 24.7109c.3774-.0737.7655-.1299 1.1625-.1678.3979-.0369.8037-.0563 1.2202-.0563.3774 0 .7752.0194 1.1918.0563.4156.0379.8136.0941 1.1919.1678.0372.0765.0853.3093.1411.7031.0569.3929.1138.814.1706 1.2631.0569.4491.1136.8807.1705 1.292.0569.4121.0844.6741.0844.7866.3783-.5995.8321-1.1795 1.3624-1.7411.5291-.5616 1.1642-1.0679 1.9013-1.5161.7372-.45 1.5693-.805 2.4974-1.067.9253-.262 1.9563-.3938 3.0923-.3938 1.7016 0 3.2815.2813 4.7391.8429 1.4554.5617 2.7031 1.4317 3.744 2.6102 1.04 1.1804 1.8534 2.6782 2.4406 4.493.586 1.8178.879 3.9594.879 6.4309 0 4.9421-1.3524 8.8084-4.0566 11.597-2.7061 2.7898-6.5356 4.1846-11.4922 4.1846-.8321 0-1.6827-.0562-2.5532-.1687-.8714-.1125-1.6269-.2629-2.2699-.4491v13.1974c-.4539.0737-.9361.13-1.4468.1678-.5106.0368-.9752.0563-1.3908.0563-.4165 0-.8791-.0195-1.3897-.0563-.5106-.0378-.9743-.0941-1.3899-.1678v-42.065Zm-11.6338 9.8289c0-2.2096-.5675-3.7442-1.7024-4.6055-1.135-.8604-2.7807-1.2911-4.937-1.2911-1.3252 0-2.5629.1038-3.7167.3086-1.1545.2064-2.2808.4771-3.3765.8137-.7195-1.2357-1.0782-2.713-1.0782-4.4367 1.2849-.4112 2.7033-.7294 4.2558-.9545 1.5506-.225 3.0444-.3366 4.4831-.3366 3.7824 0 6.658.8528 8.6251 2.5551 1.9672 1.7042 2.9512 4.428 2.9512 8.1711v18.0279c-1.324.2999-2.9315.6082-4.8231.9265-1.8927.3171-3.8226.4771-5.7888.4771-1.8543 0-3.5275-.1678-5.0222-.5054-1.4947-.3375-2.762-.8787-3.8018-1.6295-1.041-.7469-1.8446-1.7032-2.4121-2.8634-.5676-1.16-.8509-2.5636-.8509-4.2127 0-1.6081.3303-3.0223.9929-4.2397.6616-1.2153 1.5603-2.227 2.6954-3.0322 1.135-.8041 2.4405-1.4045 3.9156-1.7964 1.4761-.3938 3.0268-.5906 4.6538-.5906 1.2104 0 2.2032.0291 2.9785.0843.7754.0573 1.428.1223 1.9583.197v-1.067ZM0 52.7361l15.3224-23.5879H1.81619c-.11371-.6741-.17055-1.422-.17055-2.2465 0-.7857.05684-1.517.17055-2.1911H23.6642l.2833.7313L8.51245 49.0851H22.9831c.1127.7499.1705 1.5161.1705 2.3018 0 .7508-.0578 1.4608-.1705 2.1359H.284239L0 52.7361Zm42.0501-12.973c.8705.0756 1.5888.1493 2.1563.2241v9.1545c-.7194.1874-1.5416.327-2.469.4202-.9262.095-1.8249.1415-2.6952.1415-.6803 0-1.3996-.0368-2.1563-.1125-.7567-.0756-1.4468-.2813-2.071-.6179-.6244-.3376-1.1448-.8234-1.5604-1.4608-.4176-.6353-.6244-1.5161-.6244-2.6393 0-1.7586.6136-3.069 1.8446-3.9312 1.228-.8605 3.0159-1.292 5.3624-1.292.6047 0 1.3427.0388 2.213.1134Zm21.6203 9.6027c-.7567-.1116-1.4956-.2987-2.213-.5616V37.1236c0-1.4238.2077-2.6479.6254-3.679.4156-1.0291.9634-1.8819 1.6445-2.556.6813-.6741 1.4556-1.1795 2.3268-1.515.8694-.3375 1.778-.5063 2.7239-.5063 2.5335 0 4.3596.8806 5.4759 2.6392 1.1154 1.7606 1.6742 4.1379 1.6742 7.1332 0 1.8722-.2373 3.491-.7098 4.8567-.4734 1.3677-1.1163 2.4997-1.9297 3.3979-.8127.8992-1.7868 1.5655-2.9218 1.9942-1.1351.4307-2.3828.6461-3.7452.6461-1.2114 0-2.1945-.0572-2.9512-.1688ZM88.8097 29.092h-3.6892c-.0754-.2997-.1323-.646-.1695-1.0388-.0384-.3929-.0569-.777-.0569-1.1515 0-.3733.0185-.7584.0569-1.1513.0372-.3928.0941-.7391.1695-1.0398h9.1947v28.8122c-.4176.0737-.8802.129-1.3908.1669-.5107.0367-.9753.0562-1.3908.0562-.3784 0-.8234-.0195-1.3331-.0562-.5115-.0379-.9752-.0932-1.3908-.1669V29.092Zm32.0063 7.2453c0-1.0484-.142-2.0495-.426-3.0058-.284-.9545-.701-1.7868-1.248-2.4986-.55-.7111-1.249-1.2824-2.101-1.7122-.851-.4305-1.863-.6468-3.035-.6468-2.308 0-4.077.6934-5.307 2.0786-1.229 1.3851-1.976 3.3135-2.241 5.7848h14.358Zm12.941-11.7942c-.379.0379-.776.0941-1.192.1678v28.8113c.454.0737.936.13 1.447.1678.511.037.974.0563 1.391.0563.415 0 .88-.0193 1.389-.0563.511-.0378.974-.0941 1.391-.1678V39.2006c0-1.9459.218-3.5376.653-4.7724.434-1.2358 1.021-2.2095 1.758-2.9216.738-.711 1.569-1.2066 2.498-1.4878.927-.2804 1.901-.4211 2.922-.4211h.766c.321 0 .633.0379.937.1116.075-.4482.142-.9166.199-1.4036.056-.4859.084-.9545.084-1.4036 0-.4122-.019-.805-.057-1.1795-.037-.3734-.095-.7304-.169-1.0679-.227-.0359-.503-.0641-.824-.0834-.321-.0195-.634-.0282-.936-.0282-2.043 0-3.716.4686-5.022 1.4036-1.304.9361-2.355 2.0419-3.149 3.3144 0-.6372-.058-1.4133-.171-2.3317-.113-.9157-.227-1.6568-.34-2.2185-.341-.0737-.719-.1299-1.135-.1678-.417-.0368-.833-.0563-1.248-.0563-.417 0-.815.0195-1.192.0563ZM92.3748 11.2954c.2332-.613.3617-1.2755.3617-1.9681v-.00872c0-.69257-.1285-1.35603-.3617-1.96809-.6186-.23085-1.2888-.35792-1.9886-.35792h-.009c-.6998 0-1.3701.12707-1.9896.35792-.2322.61206-.3608 1.27552-.3617 1.96809v.00872c.0009.6926.1295 1.356.3626 1.9681.6186.2309 1.2889.3579 1.9887.3579h.009c.6998 0 1.37-.127 1.9886-.3579Z"
            fill="current"
          />
        </svg>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h4 className="ck-h5-new my-2">Zapier</h4>
        <p className="flex-1 mb-3 text-lg text-gray-600">
          Don’t see your favorite tool listed? Use Zapier to automatically add
          Clearbit data to over 1,000 web tools, including CRMs, MAPs, analytics
          platforms, and more.
        </p>
        <a
          className="ck-button-new transition duration-300 ck-button-new--small ck-button-new--link "
          href="/integrations/zapier"
        >
          Read more
          <span className="inline-block mt-1 ml-2">
            <svg
              width={6}
              height={11}
              xmlns="http://www.w3.org/2000/svg"
              className="fill-current"
            >
              <path
                d="M3.69 5.5.277 2.107a.938.938 0 0 1 0-1.331.952.952 0 0 1 1.34 0l4.121 4.096c.35.347.35.91 0 1.256l-4.12 4.096a.952.952 0 0 1-1.34 0 .938.938 0 0 1 0-1.331L3.69 5.5Z"
                fill="fill-current"
              />
            </svg>
          </span>
        </a>
      </div>
    </div>
  </div>
</section> */}


























// nice form


{/* <div className='Try'>
      <section
  id="get-started"
  className="main-container lg:py-40 md:py-32 md:flex relative items-center justify-center py-24"
>
  <img
    className="max-w-none h-[600px] left-64 bottom-12 absolute my-auto opacity-30"
    src="https://clearbit.com/images/homepage/form-background-dark.svg"
    alt="colors-background"
  />
  <img
    className="hidden mix-blend-overlay md:block max-w-none h-[386px] left-0 bottom-24 absolute w-full opacity-10"
    src="https://clearbit.com/images/homepage/form-background-dots.svg"
    alt="dots-background"
  />
  <img
    className="max-w-none h-[874px] left-2 -bottom-24 absolute my-auto"
    src="https://clearbit.com/images/homepage/form-background-colors.svg"
    alt="colors-background"
  />
  <div className="rounded-3xl md:mx-0 md:p-4 relative max-w-xl p-0 mx-auto">
    <div className="hidden md:block rounded-3xl absolute top-[20%] left-[-5%] bg-white border w-[110%] h-[60%]" />
    <div className="hidden md:block rounded-3xl absolute top-[10%] left-[-1%] bg-white border w-[102%] h-[80%]" />
    <div className="rounded-b-md md:rounded-3xl md:border relative bg-white border-t">
      <div className="contact-component relative bg-white min-h-[30rem] rounded-3xl flex flex-col pt-10 pb-6 px-6 md:px-10 lg:px-12 max-w-xl">
        <form data-hs-cf-bound="true" data-cb-wrapper="true">
          <header className="text-[#2C303E] text-center">
            <div className="ck-box z-10 w-16 h-16 m-auto mb-6 flex justify-center items-center rounded-xl shadow-none">
              <div className="" style={{ width: "100%", height: "auto" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 288 288"
                  width={288}
                  height={288}
                  className="lottie-svg"
                  preserveAspectRatio="xMidYMid meet"
                  style={{
                    width: "100%",
                    height: "100%",
                    transform: "translate3d(0px, 0px, 0px)",
                    contentVisibility: "visible"
                  }}
                >
                  <defs>
                    <clipPath id="__lottie_element_12216">
                      <rect width={288} height={288} x={0} y={0} />
                    </clipPath>
                  </defs>
                  <g clipPath="url(#__lottie_element_12216)">
                    <g
                      transform="matrix(1.0000020265579224,0,0,1.0000020265579224,184,184)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M-9.699999809265137,10 C-8.104000091552734,10 -0.6830000281333923,10 -0.6830000281333923,10 C3.0320000648498535,10 4.379000186920166,9.61299991607666 5.736999988555908,8.88700008392334 C7.09499979019165,8.16100025177002 8.16100025177002,7.09499979019165 8.88700008392334,5.736999988555908 C9.61299991607666,4.379000186920166 10,3.0320000648498535 10,-0.6830000281333923 C10,-0.6830000281333923 10,-0.6830000281333923 10,-0.6830000281333923 C10,-0.6830000281333923 10,-10 10,-10 C10,-10 -10,-10 -10,-10 C-10,-10 -10,10 -10,10 C-10,10 -9.892000198364258,10 -9.699999809265137,10"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(214,238,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M-9.699999809265137,10 C-8.104000091552734,10 -0.6830000281333923,10 -0.6830000281333923,10 C3.0320000648498535,10 4.379000186920166,9.61299991607666 5.736999988555908,8.88700008392334 C7.09499979019165,8.16100025177002 8.16100025177002,7.09499979019165 8.88700008392334,5.736999988555908 C9.61299991607666,4.379000186920166 10,3.0320000648498535 10,-0.6830000281333923 C10,-0.6830000281333923 10,-0.6830000281333923 10,-0.6830000281333923 C10,-0.6830000281333923 10,-10 10,-10 C10,-10 -10,-10 -10,-10 C-10,-10 -10,10 -10,10 C-10,10 -9.892000198364258,10 -9.699999809265137,10"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1.0000019073486328,0,0,1.0000019073486328,184,104)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M-9.163999557495117,-10 C-9.682000160217285,-10 -10,-10 -10,-10 C-10,-10 -10,10 -10,10 C-10,10 10,10 10,10 C10,10 10,0.6830000281333923 10,0.6830000281333923 C10,-3.0320000648498535 9.61299991607666,-4.379000186920166 8.88700008392334,-5.736999988555908 C8.16100025177002,-7.09499979019165 7.09499979019165,-8.16100025177002 5.736999988555908,-8.88700008392334 C4.379000186920166,-9.61299991607666 3.0320000648498535,-10 -0.6830000281333923,-10 C-0.6830000281333923,-10 -0.6830000281333923,-10 -0.6830000281333923,-10 C-0.6830000281333923,-10 -6.875999927520752,-10 -9.163999557495117,-10"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(91,173,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M-9.163999557495117,-10 C-9.682000160217285,-10 -10,-10 -10,-10 C-10,-10 -10,10 -10,10 C-10,10 10,10 10,10 C10,10 10,0.6830000281333923 10,0.6830000281333923 C10,-3.0320000648498535 9.61299991607666,-4.379000186920166 8.88700008392334,-5.736999988555908 C8.16100025177002,-7.09499979019165 7.09499979019165,-8.16100025177002 5.736999988555908,-8.88700008392334 C4.379000186920166,-9.61299991607666 3.0320000648498535,-10 -0.6830000281333923,-10 C-0.6830000281333923,-10 -0.6830000281333923,-10 -0.6830000281333923,-10 C-0.6830000281333923,-10 -6.875999927520752,-10 -9.163999557495117,-10"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1.000002145767212,0,0,1.000002145767212,104,144)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M10,-20 C10,-20 0.6830000281333923,-20 0.6830000281333923,-20 C-3.0320000648498535,-20 -4.379000186920166,-19.613000869750977 -5.736999988555908,-18.886999130249023 C-7.09499979019165,-18.160999298095703 -8.16100025177002,-17.094999313354492 -8.88700008392334,-15.737000465393066 C-9.61299991607666,-14.378999710083008 -10,-13.031999588012695 -10,-9.317000389099121 C-10,-9.317000389099121 -10,9.317000389099121 -10,9.317000389099121 C-10,13.031999588012695 -9.61299991607666,14.378999710083008 -8.88700008392334,15.737000465393066 C-8.16100025177002,17.094999313354492 -7.09499979019165,18.160999298095703 -5.736999988555908,18.886999130249023 C-4.379000186920166,19.613000869750977 -3.0320000648498535,20 0.6830000281333923,20 C0.6830000281333923,20 10,20 10,20 C10,20 10,-20 10,-20z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(15,119,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M10,-20 C10,-20 0.6830000281333923,-20 0.6830000281333923,-20 C-3.0320000648498535,-20 -4.379000186920166,-19.613000869750977 -5.736999988555908,-18.886999130249023 C-7.09499979019165,-18.160999298095703 -8.16100025177002,-17.094999313354492 -8.88700008392334,-15.737000465393066 C-9.61299991607666,-14.378999710083008 -10,-13.031999588012695 -10,-9.317000389099121 C-10,-9.317000389099121 -10,9.317000389099121 -10,9.317000389099121 C-10,13.031999588012695 -9.61299991607666,14.378999710083008 -8.88700008392334,15.737000465393066 C-8.16100025177002,17.094999313354492 -7.09499979019165,18.160999298095703 -5.736999988555908,18.886999130249023 C-4.379000186920166,19.613000869750977 -3.0320000648498535,20 0.6830000281333923,20 C0.6830000281333923,20 10,20 10,20 C10,20 10,-20 10,-20z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,144,64)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,144,64)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(15,119,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,224,144)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,224,144)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(214,238,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,144,224)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,144,224)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(15,119,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,144,144)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,144,144)"
                      opacity={1}
                      style={{ display: "block" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(91,173,255)"
                          strokeOpacity={1}
                          strokeWidth="1.5"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,104.59253692626953,103.40746307373047)"
                      opacity="0.01604666666652733"
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,104,104)"
                      opacity={1}
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(1,0,0,1,0,0)">
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(91,173,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d="M0 0"
                        />
                      </g>
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(15,119,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(15,119,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,192.0784454345703,175.9215545654297)"
                      opacity="0.01604666666652733"
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,184.00071716308594,183.99928283691406)"
                      opacity={1}
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(1,0,0,1,0,0)">
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(91,173,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d="M0 0"
                        />
                      </g>
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(214,238,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(214,238,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,104.59253692626953,184.592529296875)"
                      opacity="0.01604666666652733"
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,104,184)"
                      opacity={1}
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(1,0,0,1,0,0)">
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(91,173,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d="M0 0"
                        />
                      </g>
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(15,119,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(15,119,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,183.407470703125,104.59253692626953)"
                      opacity="0.01604666666652733"
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(255,255,255)"
                          fillOpacity={1}
                          d=" M0,-6 C3.3113999366760254,-6 6,-3.3113999366760254 6,0 C6,3.3113999366760254 3.3113999366760254,6 0,6 C-3.3113999366760254,6 -6,3.3113999366760254 -6,0 C-6,-3.3113999366760254 -3.3113999366760254,-6 0,-6z"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1,0,0,1,184,104)"
                      opacity={1}
                      style={{ display: "none" }}
                    >
                      <g opacity={1} transform="matrix(4,0,0,4,0,0)">
                        <path
                          fill="rgb(92,173,255)"
                          fillOpacity={1}
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          fillOpacity={0}
                          strokeMiterlimit={4}
                          stroke="rgb(91,173,255)"
                          strokeOpacity={1}
                          strokeWidth="7.499892730229116"
                          d=" M0,-4 C2.2076001167297363,-4 4,-2.2076001167297363 4,0 C4,2.2076001167297363 2.2076001167297363,4 0,4 C-2.2076001167297363,4 -4,2.2076001167297363 -4,0 C-4,-2.2076001167297363 -2.2076001167297363,-4 0,-4z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <h3 className="mb-6 text-2xl font-semibold">Ready to chat?</h3>
            <p className="mt-5 mb-4 text-base">
              See how the world's fastest-growing companies use Clearbit to
              power efficient revenue engines.
            </p>
          </header>
          <div>
            <label
              className="row block overflow-hidden text-left flex flex-col flex-wrap flex-auto opacity-100 mb-5"
              data-test="email"
            >
              <span className="text-[#36394A] mb-1 text-sm font-medium">
                Email
              </span>
              <input
                className="appearance-none block bg-white flex-auto rounded-lg outline-none px-1 md:px-3 h-10 text-sm border border-gray-200 focus:border-blue-500 placeholder-gray-400"
                type="email"
                name="email"
                placeholder="you@company-email.com"
                pattern="^(?!.*(gmail|hotmail|yahoo)).*$"
                required=""
                defaultValue=""
                fdprocessedid="r29qb3"
              />
            </label>
            <label
              className="row block overflow-hidden text-left flex flex-col flex-wrap flex-auto opacity-0 h-0"
              data-test="name"
            >
              <span className="text-[#36394A] mb-1 text-sm font-medium">
                Name
              </span>
              <input
                className="appearance-none block bg-white flex-auto rounded-lg outline-none px-1 md:px-3 h-10 text-sm border border-gray-200 focus:border-blue-500 placeholder-gray-400"
                type="text"
                name="name"
                placeholder="Your name"
                data-hj-whitelist="true"
                disabled=""
                defaultValue=""
                fdprocessedid="osbygr"
              />
            </label>
            <label
              className="row block overflow-hidden text-left flex flex-col flex-wrap flex-auto opacity-0 h-0"
              data-test="title"
            >
              <span className="text-[#36394A] mb-1 text-sm font-medium">
                Title
              </span>
              <input
                className="appearance-none block bg-white flex-auto rounded-lg outline-none px-1 md:px-3 h-10 text-sm border border-gray-200 focus:border-blue-500 placeholder-gray-400"
                type="text"
                name="title"
                placeholder="VP"
                data-hj-whitelist="true"
                disabled=""
                defaultValue=""
                fdprocessedid="yfts3m"
              />
            </label>
            <label
              className="row block overflow-hidden text-left flex flex-col flex-wrap flex-auto opacity-100 mb-5"
              data-test="crmSize"
            >
              <span className="text-[#36394A] mb-1 text-sm font-medium">
                Number of contacts in your database
              </span>
              <select
                className="appearance-none block bg-white flex-auto rounded-lg outline-none px-1 md:px-3 h-10 text-sm border border-gray-200 focus:border-blue-500 placeholder-gray-400"
                name="crmSize"
                fdprocessedid="ohzq21"
              >
                <option value="small">Less than 10,000 contacts</option>
                <option value="large">More than 10,000 contacts</option>
                <option value="not sure">Not sure</option>
              </select>
            </label>
            <label
              className="row block overflow-hidden text-left flex flex-col flex-wrap flex-auto opacity-100 mb-5"
              data-test="message"
            >
              <span className="text-[#36394A] mb-1 text-sm font-medium">
                Message
              </span>
              <textarea
                name="message"
                className="resize-y w-full py-3 appearance-none block bg-white flex-auto rounded-lg outline-none px-1 md:px-3 text-sm border border-gray-200 focus:border-blue-500 placeholder-gray-400"
                rows={3}
                placeholder="What are you hoping to accomplish with Clearbit?"
                required=""
                data-hj-whitelist="true"
                defaultValue={""}
              />
            </label>
          </div>
          <footer className="md:flex-row flex flex-col-reverse items-center justify-between">
            <div className="w-full">
              <button
                type="submit"
                className="ck-button-new ck-button-new--bold--blue ck-button-new--small w-full"
                fdprocessedid="lzv9h2"
              >
                Request a free data test
              </button>
              <p className="mt-3 text-xs text-center text-gray-500">
                To learn how Clearbit handles your information,
                <br /> please see our{" "}
                <a
                  target="_blank"
                  className="hover:opacity-75 whitespace-nowrap hover:underline text-blue-600"
                  href="/privacy"
                >
                  privacy policy
                </a>
                .
              </p>
            </div>
          </footer>
          <div className="text-right text-sm " />
        </form>
      </div>
    </div>
  </div>
</section>

    </div> */}